export const primaryThemeFonts = {
  font1: "d",
};
